import styled from '@emotion/styled';
import { CircularProgress, Paper } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HexagonIcon from '@mui/icons-material/Hexagon';

export const WrapperCreator = styled('div')(() => `
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 20px
`);

export const Title = styled('h2')(() => `
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
font-size: 18px;
@media (min-width: 600px){
font-size: 24px;
}
`);

export const CapitalizeTitle = styled('span')(({ theme }) => `
text-transform: capitalize;
`);

export const WrapperNotification = styled(Paper)(() => `
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 10px;
width: 100%;
padding: 6px;
text-align: left;
font-size: 12px;
@media (min-width: 600px){
width: 500px;
padding: 10px 16px;
font-size: 16px;
}
`);

export const NewInfo = styled('h3')(({ theme }) => `
color: ${theme.palette.primary.main};
font-weight: 700;
`);

export const ItemOption = styled('li')(() => `
display: flex;
justify-content: flex-start;
align-items: flex-start;
flex-wrap: nowrap;
gap: 4px;
@media (min-width: 360px){
align-items: center;
}
`);

export const IconHexagon = styled(HexagonIcon)(({ theme }) => `
width: 16px;
height: 16px;
color: ${theme.palette.primary.main};
`);

export const TextItem = styled('p')(() => `
  flex: 1; /* Il testo riempie lo spazio disponibile */
  min-width: 0; /* Permette al testo di restringersi se necessario */
  white-space: normal; /* Permette il ritorno a capo solo se necessario */
`);

export const InfoDeleteQuiz = styled.p`
max-width: 500px;
/* text-align: left; */
`;

export const PaperStyled = styled(Paper)(() => `
width: 100%;
padding: 6px;
@media (min-width: 600px){
width: 500px;
padding: 10px 16px;
}
`);

export const SubTitle = styled('h4')(() => `
margin-bottom: 10px;
`);

export const WrapperOptionStyled = styled('div')(() => `
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
gap: 20px
`);

export const QuantityStyled = styled('div')(({ theme, category }) => `
display: flex;
justify-content: center;
align-items: center;
width: 60px;
height: 60px;
padding: 6px;
border: 4px solid ${theme.palette[category].main};
border-radius: 6px;
cursor: pointer;
font-size: 16px;
font-weight: 700;
@media (min-width: 600px){
width: 100px;
height: 100px;
font-size: 24px;
}
`);

export const LevelStyled = styled('div')(({ theme, category }) => `
display: flex;
justify-content: center;
align-items: center;
width: 60px;
height: 60px;
padding: 2px;
border: 4px solid ${theme.palette[category].main};
border-radius: 6px;
font-size: 16px;
cursor: pointer;
font-size: 16px;
font-weight: 700;
text-transform: capitalize;
@media (min-width: 600px){
width: 100px;
height: 100px;
padding: 6px;
font-size: 24px;
}
`);

export const TimerStyled = styled('div')(({ theme, category }) => `
display: flex;
flex-direction: column;
justify-content: center;
gap: 6px;
align-items: center;
width: 60px;
height: 60px;
padding: 6px;
border: 4px solid ${theme.palette[category].main};
border-radius: 6px;
cursor: pointer;
font-size: 16px;
font-weight: 700;
text-transform: capitalize;
@media (min-width: 600px){
width: 100px;
height: 100px;
font-size: 24px;
}
`);

export const IconStar = styled(StarIcon)(() => `
width: 16px;
height: 16px;
@media (min-width: 600px){
width: 24px;
height: 24px;
}
`);

export const IconStarOutline = styled(StarBorderOutlinedIcon)(() => `
width: 16px;
height: 16px;
@media (min-width: 600px){
width: 24px;
height: 24px;
}
`);

export const SpinnerBtn = styled(CircularProgress)(({ theme }) => `
    color: ${theme.palette.text.light};
    margin-left: 10px;
`);

export const CreateIconStyled = styled(AddCircleOutlineIcon)(() => `
margin-left:10px;
font-size: 20px;
`);











